  (function() {
    const loadDianomiScript = () => {
      const sc = document.createElement('script');
      sc.type = 'text/javascript';
      sc.async = true;
      sc.src = 'https://www.dianomi.com/js/contextfeed.js';
      sc.charset = 'utf-8';
  
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(sc, s);
  
      sc.onload = function() {
        if(typeof dianomiReloadContext !== 'undefined') {
          dianomiReloadContext();
        }
      }        
    }
    const addDianomiDisabledStyles = () => {
      // If Dianomi is disabled by user, add 'generic' style hiding anything
      // with a j-dianomi-content class.  Allows for cleanup of things like headers
      // on bottom of home/section pages and borders on MoreHeadlines of quote page
      const css = '.j-dianomi-content { display: none !important; }';
      const styleEl = document.createElement('style');
      styleEl.type = 'text/css';
      styleEl.appendChild(document.createTextNode(css));
      document.head.appendChild(styleEl);
    }

    const checkDianomiVendor = () => {
      if (typeof __ace !== 'undefined') {
        // To get Dianomi Vendor Id (or any vendor Id) do following from Console of Marketwatch.com
        // console.table(__ace('djcmp', 'getAllVendors', []))
        __ace('djcmp', 'customVendorIsEnabled', ['5fdc7a2fa2286360b24ef388', (isVendorEnabled) => {
          if (isVendorEnabled) {
            loadDianomiScript();
          } else {
            addDianomiDisabledStyles();
          }
        }]);  
      }
    }

    // Wait for CMP to finish loading before checking if Dianomi is disabled
    if (typeof __ace !== 'undefined') {
      __ace('djcmp', 'executeOnCmpReady', [{ cb: checkDianomiVendor }]);
    }
  }());